<script lang="ts">
  import { createContext } from 'reka-ui'

  export const [useAppShell, provideAppShell] = createContext<{
    isRail: Ref<boolean>
    toggleRail: () => void
    mainMenuContent: ShallowRef<Component | null>
    setMainMenuContent: (component: Component | null) => void
    subMenuContent: ShallowRef<Component | null>
    setSubMenuContent: (
      params: {
        component: Component | null
        props?: { class?: string }
        header?: { title?: string; description?: string }
      } | null
    ) => void
  }>('app-shell')
</script>

<script setup lang="ts">
  import {
    computed,
    ref,
    type Component,
    type ShallowRef,
    shallowRef,
    type Ref
  } from 'vue'
  import AppSidebar from './app-sidebar.vue'
  import { SecondarySidebar, SidebarProvider } from '../../sidebar'

  const isRail = ref(false)
  const toggleRail = () => (isRail.value = !isRail.value)
  const mainMenuContent = shallowRef<Component | null>(null)
  const setMainMenuContent = (component: Component | null) => {
    mainMenuContent.value = component
  }

  const mainMenuWidth = computed(() => (isRail.value ? 64 : 280))

  const subMenuHeader = ref<
    { title?: string; description?: string } | undefined
  >(undefined)

  const subMenuContent = shallowRef<Component | null>(null)
  const subMenuProps = ref<{ class?: string } | undefined>(undefined)

  function setSubMenuContent(
    params: {
      component: Component | null
      props?: { class?: string }
      header?: { title?: string; description?: string }
    } | null
  ) {
    if (params) {
      const { component, props, header } = params
      subMenuContent.value = component
      subMenuProps.value = props
      subMenuHeader.value = header
      isRail.value = true
    } else {
      subMenuContent.value = null
      isRail.value = false
      subMenuHeader.value = undefined
    }
  }

  provideAppShell({
    isRail,
    toggleRail,
    mainMenuContent,
    setMainMenuContent,
    subMenuContent,
    setSubMenuContent
  })
</script>

<template>
  <!--  -->
  <div
    class="flex h-screen w-screen"
    :style="{
      paddingTop: $user.isSupportSession.value
        ? 'var(--app-status-bar-height)'
        : '0px'
    }"
  >
    <!-- Main Menu -->
    <div
      class="hidden min-h-0 w-full overflow-visible md:block"
      :style="{ maxWidth: mainMenuWidth + 'px' }"
    >
      <slot name="main-menu">
        <app-sidebar>
          <template #main-menu-content>
            <component v-if="mainMenuContent" :is="mainMenuContent" />
            <slot name="main-menu-content" v-else />
          </template>
        </app-sidebar>
      </slot>
    </div>

    <!-- Sub Menu -->
    <!-- <div
      v-if="$slots['sub-menu'] || $slots['sub-menu-content']"
      class="min-h-0 w-fit"
      :style="{ maxWidth: subMenuWidth + 'px' }"
    > -->
    <slot name="sub-menu">
      <sidebar-provider :is-rail="subMenuContent === null">
        <secondary-sidebar
          class="hidden md:block"
          :railWidth="0"
          :width="264"
          :can-toggle-rail="false"
          :header="subMenuHeader"
          :content-class="subMenuProps?.class"
        >
          <template #main-content>
            <component v-if="subMenuContent" :is="subMenuContent" />
            <slot name="sub-menu-content" />
          </template>
        </secondary-sidebar>
      </sidebar-provider>
    </slot>
    <!-- </div> -->

    <!-- Main Content -->
    <main class="min-h-0 w-full overflow-auto">
      <slot name="main" />
    </main>
  </div>
</template>
